// import { createStore } from 'redux'

import {CURRENTDESIGNATION, CURRENTLESSONKEY, CURRENTUSERID, CURRENTUSERNAME, PROFILEKEY, SUBSCRIPTIONKEY, TOKENKEY} from '../../common/constants'

export default function globalvars(state = {}, action) {
  switch (action.type) {
    case 'SET_USER_PROFILE':
      state[PROFILEKEY] = action.val
      console.log('state updated:')
      console.log(state)
      return state
    case 'SET_USER_DESIGNATION':
      state[CURRENTDESIGNATION] = action.val
      console.log('state updated:')
      console.log(state)
      return state
    case 'SET_USER_NAME':
      state[CURRENTUSERNAME] = action.val
      console.log('state updated:')
      console.log(state)
      return state
    case 'SET_USER_ID':
      state[CURRENTUSERID] = action.val
      console.log('state updated:')
      console.log(state)
      return state
    case 'RESET_DATA':
      state = action.val
      console.log('state updated:')
      console.log(state)
      return state
    case 'SET_USER_SUBSCRIPTION':
      state[SUBSCRIPTIONKEY] = action.val
      console.log('state updated:')
      console.log(state)
      return state
    case 'SET_USER_TOKEN':
      state[TOKENKEY] = action.val
      console.log('state updated:')
      console.log(state)
      return state
    case 'SET_CURRENT_LESSON':
      state[CURRENTLESSONKEY] = action.val
      console.log('state updated:')
      console.log(state)
      return state
    default:
      return state
  }
}

// const store = createStore(globalvars, ['Global vars store'])

// export default store;

// store.dispatch(setProfile('Read the docs'))

/*store.dispatch({
  type: 'GET_USER_INFO',
  text: 'Read the docs'
})*/



// WEBPACK FOOTER //
// ./src/redux/ducks/gvars.tsx